var _rect, _mask, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBasketIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 4,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 49
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 4,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0952 29.2263H9.02217V37H5V12H14.0952C19.7238 12 22.5381 14.7981 22.5381 20.3942C22.5381 23.2652 21.8255 25.455 20.4002 26.9635C18.9991 28.472 16.8974 29.2263 14.0952 29.2263ZM9.02217 25.7226H14.0589C16.9578 25.7226 18.4072 23.9465 18.4072 20.3942C18.4072 18.691 18.057 17.4501 17.3564 16.6715C16.6558 15.8929 15.5567 15.5037 14.0589 15.5037H9.02217V25.7226Z",
    fill: "#2962FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3894 12H36.8107C39.3472 12 41.2436 12.5231 42.4997 13.5693C43.7559 14.5912 44.384 16.2336 44.384 18.4964C44.384 19.9805 44.1424 21.1484 43.6593 22C43.2003 22.8516 42.4635 23.5572 41.4489 24.1168C43.8163 25.0414 45 26.9757 45 29.9197C45 34.6399 42.3669 37 37.1006 37H27.3894V12ZM36.8107 26.0876H31.4116V33.4964H36.8832C38.2118 33.4964 39.2023 33.2165 39.8545 32.6569C40.5309 32.0973 40.8691 31.1363 40.8691 29.7737C40.8691 28.4112 40.4826 27.4623 39.7096 26.927C38.9365 26.3674 37.9703 26.0876 36.8107 26.0876ZM36.5933 15.5037H31.4116V22.6569H36.7382C39.1056 22.6569 40.2893 21.4282 40.2893 18.9708C40.2893 16.6594 39.0573 15.5037 36.5933 15.5037Z",
    fill: "#2962FF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBasketIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Basket-Icon.775fab7b.svg";
export { ForwardRef as ReactComponent };